import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';

const SectionHeader = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionHeader'));
const SectionCharges = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionCharges'));
const SectionUnderstanding = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionUnderstanding'));
const SectionFactors = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionFactors'));
const SectionStrategies = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionStrategies'));
const SectionMinimise = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionMinimise'));
const SectionFeatures = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionFeatures'));
const SectionKey = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionKey'));
const SectionImpact = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionImpact'));
const SectionKeyOsra = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionKeyOsra'));
const SectionTrucking = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionTrucking'));
const SectionSignUp = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionSignUp'));
const SectionFaq = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionFaq'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionRelatedPosts'));

interface IProps {
  articles: TopArticlesCardType[];
}

export default function DemurrageAndDetentionPage({ articles }: IProps) {
  return (
    <div className="demurrage-and-detention">
      <div className="container">
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Demurrage and Detention', href: '' }]} />
      </div>
      <SectionHeader/>
      <SectionCharges/>
      <SectionUnderstanding/>
      <SectionFactors/>
      <SectionStrategies/>
      <SectionMinimise/>
      <SectionFeatures/>
      <SectionKey/>
      <SectionImpact/>
      <SectionKeyOsra/>
      <SectionTrucking/>
      <SectionSignUp/>
      <SectionFaq/>
      <SectionRelatedPosts articles={articles}/>
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'Demurrage & Detention Guide | DF Alliance',
    description:
      'Learn about demurrage and detention policies with DF Alliance to better understand the cost management aspects of global freight forwarding.',
    path: '/resources/demurrage-and-detention',
  };
  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { articles, ...meta } };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }
  return {
    props: {
      articles: [],
      ...meta,
    },
  };
};

DemurrageAndDetentionPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
